// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3CNYi","content":"RecentSearches_content__2Ecoa"};